<article class="formEditor">
    <span class="formLabel">Accounts</span>
    <lib-generic-type-ahead-multiselect
        [source]="items()"
        [selectedItems]="selectedItems()"
        [placeholder]="placeholderText()"
        [isReadOnly]="isReadOnly()"
        (selectedItemsChange)="onSelectedItemsChange($event)"
        (textChange)="onEntityTextChange($event)"
        [config]="{
            defaultText: placeholderText(),
            multiple: true,
            itemDisplayKey: 'name'
        }"
    >
    </lib-generic-type-ahead-multiselect>
</article>
